import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core';
import {
    Chart,
    PieSeries,
} from '@devexpress/dx-react-chart-material-ui';

import { Animation } from '@devexpress/dx-react-chart';

export default function DonutChart(props) {
    const classes = useStyles();
    const [chartData, setChartData] = useState([]);
    const [dataFetched, setdataFetched] = useState(false);

    const pointComponent = props => <PieSeries.Point {...props}
        arg={90}
        val={60}
        color={props.argument}
        value={props.value}
        innerRadius={props.innerRadius}
        startAngle={props.startAngle - 2.7}
        endAngle={props.endAngle - 2.7}
    >
    </PieSeries.Point>

    useEffect(() => {
        let value = 85 * (props.value / 100)
        let color = ""
        if (props.value > 75) {
            color = "#5CC958"
        }
        else if (props.value > 50) {
            color = "#F59127"
        }
        else {
            color = "#D84949"
        }

        let newChartdata = [{ color: color, val: value }, { color: '#DEDEDE', val: 85 - value }, { color: 'white', val: 15 }];
        if (JSON.stringify(newChartdata) !== JSON.stringify(chartData)) {
            setChartData(newChartdata)
        }

        setdataFetched(true);
    }, [props.value, chartData]);


    return (
        <React.Fragment>
            {dataFetched ? <React.Fragment> <div className={classes.chart}>
                <React.Fragment>
                    <Chart
                        data={chartData}
                    >
                        <PieSeries
                            className={classes.donut}
                            valueField="val"
                            argumentField="color"
                            innerRadius={0.6}
                            pointComponent={pointComponent}
                        >
                        </PieSeries>
                        <Animation />
                    </Chart>
                </React.Fragment>

            </div>
                <div className={classes.circle}>{props.value}</div>
                <div className={classes.label}>{props.label}</div> </React.Fragment> : <React.Fragment></React.Fragment>}
        </React.Fragment>
    )
}

const useStyles = makeStyles(() => ({
    chart: {
        width: "150px",
        height: "150px"
    },
    circle: {
        height: "80px",
        width: "80px",
        marginLeft: "60px",
        bottom: "120px",
        fontSize: "25px",
        paddingTop: "22px",
        backgroundColor: "white",
        boxShadow: "0 0 15px 5px rgba(0,0,0,0.3)",
        borderRadius: "100px",
        zIndex: "1",
        position: "relative",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: '#020100',
        textAlign: "center",
        boxSizing: "border-box"
    },
    label: {
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: '#020100',
        textAlign: "center",
        position: "relative",
        fontSize: "16px",
        bottom: "83px"
    },
    donut: {
        height: "150px"
    }
}));